<div class="row account-filter align-content-end">
  <div class="input-group justify-content-end" [ngClass]="{'disabled': disabled}">
    <span class="w-100 input-group-text bg-transparent border-1 border-left filter-container">
      <a class="nav-link dropdown-toggle py-1" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"
        data-bs-auto-close="outside" #dropdownTrigger>
        <i class="ph ph-funnel-simple"></i>
        <span class="text-dark px-2">{{ isLoading ? 'Loading accounts ...' : placeholder }}</span>
      </a>

      <span *ngIf="selectedAccountsCount > 0" class="bg-danger text-white py-1 px-2 rounded-2 text-xs">
        {{ selectedAccountsCount}}
      </span>

      <ul class="dropdown-menu custom-dropdown border-0" #dropdown>
        <div class="sticky-top bg-white p-2">
          <div class="input-group align-items-center">
            <div
              class="col-1 ps-2 d-flex justify-content-center align-items-center rounded-start-3 border-1 search-icon">
              <i class="ph ph-magnifying-glass"></i>
            </div>

            <div class="col-11">
              <input type="text" class="ps-3 rounded-end-3 border-1 search-input" aria-label="Search" [placeholder]="
              isLoading ? 'Loading accounts ...' : 'Search accounts'" [(ngModel)]="accountName"
                (input)="searchAccounts($event)" (click)="openDropdown($event)" />
            </div>
          </div>
        </div>

        <div class="dropdown-scroll">
          <ng-container *ngTemplateOutlet="accountsTreeList; context: { items: filteredTree }"></ng-container>
        </div>
      </ul>

      <ng-template #accountsTreeList let-items="items">
        <li *ngFor="let item of items; let i = index" class="dropdown-item">
          <label [ngClass]="{
              'parent-item':
                item.hierarchyLevel === 0 || item.children?.length > 0
            }">
            <input type="checkbox" [checked]="item.checked" (click)="onCheckboxChange(item)" />
            {{ item.name }}
          </label>
          <ul *ngIf="item.children?.length">
            <ng-container *ngTemplateOutlet="
                accountsTreeList;
                context: { items: item.children }
              "></ng-container>
          </ul>
          <div *ngIf=" item.hierarchyLevel === 1 && item.children?.length" class="hierarchy-line"></div>
        </li>
      </ng-template>
    </span>
  </div>
</div>